import { useEffect, useState } from "react";

/**
 * useLocalStorageState — small persisted state hook.
 * JSON-serialises the value. Returns [value, setValue].
 */
export function useLocalStorageState(key, initialValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = window.localStorage.getItem(key);
      if (raw === null) return initialValue;
      return JSON.parse(raw);
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // ignore quota / disabled storage
    }
  }, [key, value]);

  return [value, setValue];
}
